import $store from '@/store'

export default {
	field_types () {
		var types = {
      "checkbox": "CheckBox",
      "text": "TextField",
      "file": "FileSelect",
      "s3file": "S3FileSelect",
      "select": "ItemSelect",
      "list_select": "ListSelect",
      'key_value': "KeyValue",
      "uuid": "Uuid",
      "textarea": "TextArea",
      "markdown": "MarkDown",
      "datetime": "DateTime",
      "date": "Date",
      "multiline": "MultiLine",
      "content_select": "ContentSelect",
      "setting-select": "SettingSelect",
      "setting_select": "SettingSelect",
      "number": "Number",
      "playoff_tree": "PlayoffTree"
    }
    return types;
	},
  get_field_type(field_type) {
    var types = this.field_types();
    var ret = types[field_type];
 //   if (typeof(ret) == "undefined") return field_type;
    return ret;
  }
}
